import router                              from "@/router";
import {isNil}                             from "lodash";
import {createNewUserFromFirebaseAuthUser} from "@/misc/helpers";
import UsersDB                             from "@/firebase/users-db";

export default {
    /**
     * Callback fired when user login
     */
    login: async ({commit, dispatch}, firebaseAuthUser) => {
        const userFromFirebase = await new UsersDB().read(firebaseAuthUser.uid);

        const user = isNil(userFromFirebase) ? await createNewUserFromFirebaseAuthUser(firebaseAuthUser) : userFromFirebase;
        
        if (typeof undefined === typeof userFromFirebase.role || userFromFirebase.role === "") {
            dispatch("logout");
            return;
        }

        // eslint-disable-next-line no-unused-expressions
        window.OneSignal && window.OneSignal.push(
            () => {
                window.OneSignal.sendTags(
                    {
                        displayName       : userFromFirebase.displayName,
                        email             : userFromFirebase.email,
                        notificationMethod: userFromFirebase.notificationMethod ? "SMS" : "Push Notification",
                        phoneNumber       : userFromFirebase.phoneNumber,
                        role              : userFromFirebase.role
                    }
                );
            }
        );

        commit("setUser", user);

        setTimeout(
            () => {
                router.push(
                    {
                        name: "demands"
                    }
                );
            },
            500
        );
    },

    /**
     * Callback fired when user logout
     */
    logout: ({commit}) => {
        commit("setUser", null);
        commit("setUsers", []);
        commit("chats/emptyMessages", null, {root: true});
        commit("demands/setDemands", [], {root: true});
        commit("demands/setDemandsFormSaving", false, {root: true});
        commit("demands/setDemandsLoading", false, {root: true});

        const currentRouter = router.app.$route;
        if (!(currentRouter.meta && currentRouter.meta.authNotRequired)) {
            router.push("/login");
        }
    },

    updateUser: async (state, user) => {
        const userDb = new UsersDB();

        await userDb.update(user);
    },

    getUsersAction: async ({commit}) => {
        const userDb = new UsersDB();
        const users  = await userDb.readAll();

        commit("setUsers", users);
    },

    getUserAction: async (state, userID) => {
        const userDb = new UsersDB();
        const user   = await userDb.read(userID);

        return user;
    }
};
